import React, {Component} from 'react'
import PropTypes from 'prop-types'

class BarcodeColumn extends Component {
    render() {
        const {barcode} = this.props

        return <td className="OrderNumber">
            <span className="d-flex flex-column">
                {barcode && <span className="text-primary">#{barcode}</span>}
            </span>
        </td>
    }
}

BarcodeColumn.propTypes = {
    barcode: PropTypes.number
}

export default BarcodeColumn